import { render, staticRenderFns } from "./logisticIndex.pug?vue&type=template&id=5a7fdca5&scoped=true&lang=pug&"
import script from "./logisticIndex.ts?vue&type=script&lang=ts&"
export * from "./logisticIndex.ts?vue&type=script&lang=ts&"
import style0 from "./logisticIndex.scss?vue&type=style&index=0&id=5a7fdca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7fdca5",
  null
  
)

export default component.exports